import { createSelector } from '@ngrx/store';

export const getWardsState = createSelector(
    (state: any) => state.wards,
    (state: any) => state.get('list')
);

export const getCreateWardState = createSelector(
    (state: any) => state.wards,
    (state: any) => state.get('createWard')
);

export const getUpdateWardState = createSelector(
    (state: any) => state.wards,
    (state: any) => state.get('updateWard')
);
 